import { useMutation, useQueryClient } from '@tanstack/react-query'

import { post } from '../apiClient'
import { type CancelRecurringReservationBody } from '../../../common/validations/reservationSchema'
import {
  CancelRecurringReservationResponse,
  CancelRecurringReservationResponseSchema,
} from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type CancelRecurringReservationRequest = CancelRecurringReservationBody

export const useAPICancelRecurringReservation = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: CancelRecurringReservationRequest
    ): Promise<CancelRecurringReservationResponse> => {
      const response = await post(
        `/contracts/${contractId}/reservations/cancelRecurring`,
        request as unknown as Record<string, unknown>,
        CancelRecurringReservationResponseSchema
      )
      return response
    },
    throwOnError: false,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['reservations', contractId],
      })

      queryClient.invalidateQueries({
        queryKey: [
          `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`,
        ],
      })

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as string
          return (
            key?.includes(
              `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`
            ) && key?.includes('/time-slots')
          )
        },
      })
    },
  })
}
